export default __webpack_public_path__ + "static/media/it-park-brand.15745e3d.svg";